module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0099.jpg?v=17dba8f3";